<template>
<div class="select-container">
  <FormItem :label="label" :prop="$attrs.name" :name="$attrs.name">
    <Select ref="formInput" v-bind="$attrs" v-on="$listeners" @search="handleInputKeyDown" @select="resetOptions()">
      <Option
        v-for="(item, index) in items"
        :key="`${item[valuePath]}-${index}`"
        :value="item[valuePath] || item"
        :disabled="item.disabled"
      >
        {{
          humanizeLabel
            ? $options.filters.humanize(item[labelPath] || item)
            : item[labelPath] || item
        }}
      </Option>
    </Select>
  </FormItem>
    <a-tooltip>
      <template slot="title">
        <p>To preview the College Name of your choice, begin typing the name of the College and select the College you want to view from the drop-down menu.</p>
      </template>
      <BaseIcon class="pop-tip-wrapper tooltip-icon select-info-icon" type="info-circle" />
    </a-tooltip>
  </div>
</template>

<script>
import { Select, FormModel } from "ant-design-vue";

const { Option } = Select;
const FIELDS = "id, collegeName";
const COLLEGE_STORE_KEY = "collegeStore";

export default {
  data(){
    return{
      searchKey:''
    }
  },
  components: {
    Select,
    Option,
    FormItem: FormModel.Item
  },
  props: {
    label: {
      type: String,
      default: ""
    },
    items: {
      type: Array,
      required: true
    },
    valuePath: {
      type: String,
      default: "id"
    },
    labelPath: {
      type: String,
      default: "name"
    },
    humanizeLabel: {
      type: Boolean,
      default: true
    }
  },
  watch:{
    'searchKey':{
      handler : function (searched){
        this.getAllColleges(searched)
      },
    }
    
  },
  methods:{
    handleInputKeyDown(event){
      this.searchKey = event
    },
    async resetOptions(){
      await this.$store.dispatch(`${COLLEGE_STORE_KEY}/getAllColleges`, {
        fields: FIELDS,
        sort: "collegeName",
        limit:200,
        searchField:'collegeName',
      });
    },
   async getAllColleges(searched){
     if(searched.length >= 4){
       const d =/\s{2}/.test(searched);
       if(d === false){
         await this.$store.dispatch(`${COLLEGE_STORE_KEY}/getAllColleges`, {
            fields: FIELDS,
            sort: "collegeName",
            limit:200,
            searchField:'collegeName',
            q:searched
          });
       }
     }
    }
  },
};
</script>

<style lang="scss">
.select-container{
  display: flex;
  justify-content: space-around;
  align-items: center;
  .select-info-icon{
    font-size: 1.3em;
    margin: 0 0px 0px 5px;

    svg{
      fill: #59B5FF;
    }
  }
}
</style>